import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Marker } from 'google-maps-react';

import GoogleApiWrapper from '../../common/MapContainer/MapContainer';
import LoadingSpinner from '../../common/LoadingSpinner/LoadingSpinner';
import ErrorScreen from '../../common/ErrorScreen/ErrorScreen';

import { StyledHomeMap } from './styles/StyledHomeMap';


const defaultMapCenter = {
  lat: 50.090941, 
  lng: 14.400465,
}

class OfficesMap extends Component {
  constructor(props) {
    super(props);

    this.onMarkerClick = this.onMarkerClick.bind(this);
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.props.officesData.isLoading !== nextProps.officesData.isLoading) {
      return true;
    }
    if (this.props.officesData.status !== nextProps.officesData.status) {
      return true;
    }
    if (this.props.enterOfficeId !== nextProps.centerOfficeId) {
      return true;
    }
    return false;
  }

  onMarkerClick(e, officeId) {
    this.props.router.push('/office/' + officeId);
  }
  
  render() {
    // centerOfficeId - for highligh position
    const { centerOfficePos, centerOfficeId } = this.props;
    const { data, isLoading, status, } = this.props.officesData;

    if (isLoading) {
      return (
        <StyledHomeMap>
          <div className="home-map-container">
            <LoadingSpinner />
          </div>
        </StyledHomeMap>  
      );
    }

    if (!status) {
      return (
        <StyledHomeMap>
          <div className="home-map-container">
            <ErrorScreen />
          </div>
        </StyledHomeMap>  
      );
    }

    let markers = [];
    for (let i = 0; i < data.length; i++) {
      if (data[i].lat === null || data[i].lon === null) 
        continue;
      markers.push(
        <Marker 
          key={'dataMap' + data[i].id}
          title={data[i].pub_server_name + '\n' + data[i].server_address}
          name={data[i].pub_server_name}
          position={{lat: data[i].lat, lng: data[i].lon}}
          onClick={e => this.onMarkerClick(e, data[i].id)}
        />
      );
    }

    
    return (
      <StyledHomeMap>
        <div className="home-map-container">
          <GoogleApiWrapper 
            initCenter={defaultMapCenter}
            initZoom={7}
            centerTo={centerOfficePos}
            centerOfficeId={centerOfficeId}
            markers={markers}
          />
        </div>
      </StyledHomeMap>      
    );
  }
}


OfficesMap.propTypes = {
  officesData: PropTypes.object.isRequired,
  centerOfficePos: PropTypes.object.isRequired,
  centerOfficeId: PropTypes.number.isRequired,
};


export default OfficesMap;


// WEBPACK FOOTER //
// ./src/components/OfficesMap/OfficesMap.js